import React from 'react';
import CheckboxTree from 'react-checkbox-tree';
import '../css/tree-view.css';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import {connect} from 'react-redux';
import {putDataInDevCenterDataStore} from '../../../../../app/store';
import {addItemsToJsonTree,removeItemsToJsonTree,compareTwoArraysAndRemoveDuplicates,iterateJsonAndGetPrimitiveJson} from '../js/js-tree-operations';
import {sortCheckedList} from '../../../actions/rhs-schema-actions';
import {getJsTreeChecked,getExampleValue} from '../../../../dynamic/reducers/examples-reducer';
import {getJsTree,getJsTreeExpanded,getJsTreeExpandedFlag,getSchema} from '../../../../dynamic/reducers/rhs-schema-reducer';
import showDivBasedOnId, {  clickDivBasedOnId, hideDivBasedOnId, setDisplayFlexBasedOnId, setDisplayVisibleBasedOnId } from '../../../../../commons/ui-commons';

class JsTree extends React.Component {
    state = {
        checked: [],
        clicked: {},
        expanded: []
    };

    constructor(props) {
        super(props);
        this.onCheck = this.onCheck.bind(this);
        this.onExpand = this.onExpand.bind(this);
        this.onClick = this.onClick.bind(this);
    }

    onCheck(checked,targetNode) {
        addItemsToCheckedList(checked,targetNode["value"]);
        //if(this.props.)
        this.setState(getJsTreeChecked());
    }   

    onExpand(expanded) {
        this.setState({ expanded });
        hideDivBasedOnId("JstreeLoaderIndicator");
        showDivBasedOnId("requestBuilderJsTreeTab");
        hideDivBasedOnId("BodyTabLoaderIndicator");
        showDivBasedOnId("bodyTab");
        setDisplayFlexBasedOnId("sample-request-data");
        clickDivBasedOnId("bodyTab");
        setDisplayFlexBasedOnId("live-console");
        setDisplayVisibleBasedOnId("live-console");
        clickDivBasedOnId("live-console");
        var editor = document.querySelector('.CodeMirror').CodeMirror;
        setTimeout(function() {
            editor.refresh();
            let titleInfoElements = document.querySelectorAll('.react-checkbox-tree .rct-title > svg');
            for (var i = 0; i < titleInfoElements.length; i++) {
                let titleElement = titleInfoElements[i].parentElement;
                titleElement.setAttribute('aria-label', "Opens dialog for field " + titleElement.textContent);
            }
        },1)
    }

    onClick(clicked) {
        this.setState({ clicked });
        if(typeof clicked.label === 'object'){
            putDataInDevCenterDataStore({type: 'UPDATE_NODE_CLICK_CHECK', nodeClickCheck: true})
            putDataInDevCenterDataStore({type: 'UPDATE_CLICKED_NODE', clickedNode: 'request-Body-'+clicked.value})
        }
    }

    render() {
        var jsTreeReducer = getJsTreeExpanded();
        var jsTreeExpandedFlag = getJsTreeExpandedFlag();
        if((this.state.expanded.length == 0 || jsTreeExpandedFlag) && jsTreeReducer && jsTreeReducer.length){
            putDataInDevCenterDataStore({type:'UPDATE_JS_TREE_EXPANDED_FLAG', jsTreeExpandedFlag: false});
            this.onExpand(jsTreeReducer);
        }
        var jsTreeNew = getJsTree();
        if(!jsTreeNew){
            jsTreeNew = []
        }
        return (
        
            <CheckboxTree
            id ="jsTreeContent"
            checked={getJsTreeChecked()}
            expanded={this.state.expanded}
            clicked={this.state.clicked}
            iconsClass="fa5"
            nodes={jsTreeNew}
            // optimisticToggle={false}
            onCheck={this.onCheck}
            onExpand={this.onExpand}
            onClick={this.onClick}
            showNodeTitle = {true}
        />
        );
    }
}

function mapStateToProps(state){
    return{
        jsTree: state.rhsReducer.jsTree,
        jsTreeChecked:state.examplesReducer.jsTreeChecked,
        // exampleValue:state.examplesReducer.exampleValue,
        nodeClickCheck: state.rhsReducer.nodeClickCheck,
    }
}

function addItemsToCheckedList(checkedItems,targetNode)
{
    var prevCheckItems = getJsTreeChecked();
    var jsTreeContents = getJsTree();
    var sortedCheckedItems = sortCheckedList(checkedItems, jsTreeContents)
    putDataInDevCenterDataStore({type:'UPDATE_JS_TREE_CHECK_BOX',jsTreeChecked:sortedCheckedItems});
    var exampleValue = JSON.parse(getExampleValue());
    
    if(prevCheckItems != undefined)
    {
        var newExampleValue = {};
        if(prevCheckItems.length < sortedCheckedItems.length)
        {
            for(var items in sortedCheckedItems)
                {
                    // console.log(checkedItems[items]);
                    newExampleValue = addItemsToJsonTree(sortedCheckedItems[items],exampleValue,newExampleValue,jsTreeContents);
                }
        }
        else
        {
            prevCheckItems.sort().reverse();
            checkedItems.sort().reverse();
            var uncheckedContents = compareTwoArraysAndRemoveDuplicates(prevCheckItems,checkedItems);
            for(var items in uncheckedContents)
                {
                    // console.log(uncheckedContents[items]);
                    exampleValue = removeItemsToJsonTree(uncheckedContents[items],exampleValue,null,jsTreeContents);
                }
        }

        if(JSON.stringify(newExampleValue) === '{}'){
            newExampleValue = exampleValue;
        }  

        if("properties" in getSchema())
        {
            var schemaValue = getSchema();
            putDataInDevCenterDataStore({type:'UPDATE_REQUEST_VALUE',requestValue:iterateJsonAndGetPrimitiveJson(schemaValue["properties"],newExampleValue)});
        }
    }
    putDataInDevCenterDataStore({type:'UPDATE_EXAMPLE_VALUE',exampleValue:JSON.stringify(newExampleValue, null, 2)});
}
export default connect(mapStateToProps)(JsTree);
